exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vgt-wrap[data-v-35cd49d9] .vgt-table thead{visibility:hidden;line-height:0!important}.vgt-wrap[data-v-35cd49d9] .vgt-table thead tr th{padding:0!important}", ""]);

// exports
